import React, { FC } from 'react';
import { FieldValue, FieldValueType } from 'api/tasks';
import { Priority } from 'components/atoms/priority';
import { useSelectedPriority } from 'data/fields/hooks/account-fields';

/* TODO:: Instead of apssing fields array, this can take priority field directly. */
export const PriorityCell: FC<{ fields: FieldValue<FieldValueType>[] }> = ({
  fields,
}) => {
  const priority = useSelectedPriority(fields);

  return priority ? <Priority priority={{ ...priority }} /> : <></>;
};
